<template>
  <div class="product">
    <div>
      <SwiperList :swiperList="swiperList"></SwiperList>
    </div>
    <div class="w-inner">
      <div class="demo" flex="dir:left box:first" style="padding-top: 20px;padding-bottom: 20px;">
        <div style="margin-right: 30px;">
          <div class="left">
            <div>
              <h3 style="color: #0061ca;padding: 20px 0 20px 25px"><span
                style="color:#ff8e0a;margin-right: 5px;font-size: 16px;font-weight: 900;margin-top: -3px;">|</span>栏目导航<span
                style="margin-left: 5px;">Navgation</span></h3>
            </div>
            <ul class="ul-left">
              <li style="position: relative" v-for="(item, index) in list" @click="click(index, item)"
                  v-bind:class="{clicked: item.opermtid === secondActiveTab}">{{item.opermtname}}
                <img src="../../assets/images/jiantou.png" height="18" width="18"
                     style="position: absolute;top: 20px;right: 25px;"/>
              </li>
            </ul>
          </div>
        </div>

        <div class="right relative" style="height: auto;color: #666;">
          <div style="border-bottom: 2px solid #f6f6f6;padding-top: 10px;">
            <div style="padding-bottom: 6px;margin-top: 2px;position: relative">{{secondTitle}}
              <div style="border-bottom: 2px solid #0061ca;width: 120px;position: absolute;bottom: -2px;left: 0;"></div>
            </div>
          </div>
          <div v-if="operflg===1" class="content-flg" style="padding-top: 10px;">
            <div v-html="contents"></div>
          </div>
          <div v-else-if="operflg===2">
            <pic-view :pics="pics"></pic-view>
          </div>
          <div v-else-if="operflg===3" class="news-list">
            <div v-for="item in list1" @click="Link(item.operwconid)">
              <ul>
                <li style="cursor: pointer;padding: 4px 0;" class="b-d-b">
                  <span style="margin-right:5px;color: #4984c1">❉</span>{{item.operwcontitle}}
                  <span href="#" style="float:right;margin-right:20px;">{{item.createtime | shortDate}}</span>
                </li>
              </ul>
            </div>
            <div>
              <page @pageChanged="pageChanged" :total="total" :pageSize="pageSize" :currentPage="currentPage"></page>
            </div>
          </div>
          <div v-else-if="operflg===4" class="news-list">
            <div v-for="item in list1" >
              <ul>
                <li style="cursor: pointer;padding: 4px 0;" class="b-d-b">
                  <span @click="Link(item.operwconid)" style="margin-right:5px;color: #4984c1">❉</span>{{item.operwcontitle}}
                  <span  href="#"  @click.stop="downF(item)" style="float:right;margin-right:20px;">下载</span>
                </li>
              </ul>
            </div>
            <div>
              <page @pageChanged="pageChanged" :total="total" :pageSize="pageSize" :currentPage="currentPage"></page>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import SwiperList from './SwiperList.vue'
  import {mapState} from 'vuex'
  import _ from 'lodash'
  import Page from '../common/Page.vue'
  import common from '../../mixin/common'
  import PicView from '../common/PicView.vue'
  import utils from '../../assets/js/utils.js'

  export default {
    mixins: [common],
    data () {
      return {
        list: [],
        list1: [],
        type: 0,
        operflg: 0,
        contents: '',
        appends: [],
        swiperList: [],
        limit: 0,
        offset: 0,
        currentPage: 1,
        count: 0,
        flg: 0,
        leftId: 0
      }
    },
    created () {
      this.findSwiperList()
      this.getList()
    },
    watch: {
      $route () {
        this.leftId = 0
        this.getList()
        this.findSwiperList()
      }
    },
    methods: {
      downF (item) {
        console.log(item)
        if (item.appends.length) {
          this.downFile(item.appends[0].appendurl)
        }
      },
      // 轮播
      findSwiperList () {
        this.$store.dispatch('findSwiperList', {operadmtid: this.$route.params.operMtId}).then(data => {
          if (data) {
            this.swiperList = data.appends
          }
        })
      },
      click (index, item) {
        this.currentPage = 1
        this.leftId = item.opermtid
        this.$store.commit('changId', '')
        this.getRightData(item)
      },
      // 右边
      getRightData (item) {
        this.flg = item.opermtmtflg
        this.$store.commit('setSecondActiveTab', this.opermtid ? this.secondActiveTab : item.opermtid)
        this.getMsg(item.opermtid)
      },
      // 左边
      getList () {
        this.$store.dispatch('findHelpLeftList', {opermtparentid: this.$route.params.operMtId}).then(data => {
          this.list = data
          // let index = this.list.findIndex(v => v.opermtid === this.secondActiveTab)
          let that = this
          let index = _.findIndex(this.list, function (o) { return o.opermtid === that.secondActiveTab })
          if (index === -1) {
            index = 0
          }
          this.getRightData(this.list[index])
        })
      },
      getMsg (opermtid) {
        this.$store.dispatch('getWconList', {
          opermtid: this.opermtid ? this.opermtid : opermtid,
          limit: this.limit ? this.limit : this.pageSize,
          offset: this.offset
        }).then(data => {
          this.list1 = data
          if (this.flg === 1 && data.length > 0) {
            this.contents = data[0].operwconcontents
            if (this.contents.length) {
              this.contents = this.contents.replace(/upload/g, this.picAddr + 'upload')
            }
          } else {
            this.contents = ''
          }
          if (this.flg === 2 && this.list1.length) {
            this.appends = this.list1[0].appends
          }
        })
        this.operflg = this.flg
      },
      // 分页
      pageChanged (val) {
        this.currentPage = val.currentPage
        this.limit = val.limit
        this.offset = val.offset
        this.getList()
      },
      Link (id) {
        this.$router.push({
          name: 'WconDetail',
          query: {id: id, mtid: this.$route.params.operMtId, leftId: this.leftId}
        })
      }
    },
    filters: {
      shortDate: function (val) {
        return utils.formatterDate(val, 'yyyy-MM-dd')
      }
    },
    components: {SwiperList, Page, PicView},
    computed: {
      ...mapState({
        secondActiveTab: state => state.secondActiveTab,
        opermtid: state => state.id,
        pageSize: state => state.pageSize,
        total: state => state.total,
        picAddr: state => state.picAddr
        // secondTitle: state => state.secondTitle
      }),
      secondTitle () {
        if (this.list.length) {
          if (!this.leftId && !this.opermtid) {
            return this.list[0].opermtname
          } else if (this.opermtid) {
            // let item = this.list.find(v => v.opermtid === this.opermtid)
            let item = _.findKey(this.list, v => v.opermtid === this.opermtid)
            return item ? item.opermtname : ''
          } else {
            let item = this.list.find((item) => {
              return item.opermtid === this.leftId
            })
            // let item = this.list.find(v => v.opermtid === this.leftId)
            // let item = _.findKey(this.list, v => v.opermtid === +this.leftId)
            return item ? item.opermtname : ''
          }
        }
      },
      pics () {
        if (this.appends.length) {
          // let showText = this.appends.findIndex(v => v.appendcontent.length > 0)
          let showText = _.findIndex(this.appends, v => v.appendcontent.length > 0)
          if (showText !== -1) {
            showText = true
          } else {
            showText = false
          }
          return this.appends.map(v => {
            let contents = v.appendcontent.split('&')
            return {sort: v.appendsort, url: v.appendurl, content: v.appendcontent, contents, showText}
          })
        }
      }
    }
  }
</script>

<style lang="stylus" scoped>
  .product
    .left
      width: 290px !important;
      border: 1px solid #f5f5f5;
    .active
      color: blue !important;
    .piccontainer
      display flex
      padding-top 10px
      flex-wrap wrap
      .pic
        box-shadow 0 2px 12px 0 rgba(0, 0, 0, .1)
        display flex
        justify-content center
        align-items center
        border 1px solid #ebeef5
        background-color #fff
        transition .3s
        overflow hidden
        margin 5px
        border-radius 2px
        width 32%
        padding 20px
        img
          width 100%
      .contents
        display flex
        justify-content center

</style>




// WEBPACK FOOTER //
// WebProduct.vue?f5fa862e